<template>
  <div class="app-languages" ref="app-languages">
    <div class="app-language-box app-language-box_current">
      <span class="app-language" @click="toggleLanguages">
        {{ language.value }}
      </span>
    </div>

    <div class="app-languages__options" v-if="isLanguagesShow">
      <div
        v-for="item in languages"
        :key="item.id"
        class="app-language-box app-language-box_current"
      >
        <span
          class="app-language"
          :class="{
            'app-language_active': language.value == item.value,
          }"
          @click="chooseLanguage(item)"
        >
          {{ item.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-languages",
  data() {
    return {
      isLanguagesShow: false,
      language: {
        value: "DE",
      },
      languages: [
        {
          id: 0,
          value: "DE",
        },
        {
          id: 1,
          value: "EN",
        },
      ],
    };
  },
  methods: {
    toggleLanguagesListener(e) {
      if (this.$refs["app-languages"].contains(e.target) == false) {
        this.isLanguagesShow = false;

        document.removeEventListener("click", this.toggleLanguagesListener);
        return;
      }
    },

    toggleLanguages() {
      if (this.isLanguagesShow == false) {
        document.addEventListener("click", this.toggleLanguagesListener);
      }

      this.isLanguagesShow = !this.isLanguagesShow;
    },

    chooseLanguage(item) {
      this.toggleLanguages();
      if (this.language.value != item.value) {
        this.$i18n.locale = item.value.toLowerCase();
        this.languages.reverse();
      }
      this.language = item;
      localStorage.setItem("language", JSON.stringify(item));
    },

    initLanguage() {
      let language = localStorage.getItem("language");

      if (language) {
        language = JSON.parse(language);
        this.chooseLanguage(language);
        this.toggleLanguages();
      }
    },
  },
  mounted() {
    this.initLanguage();
  },
};
</script>
